import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bibShape } from '@bibliocommons/bc-prop-types';

import { FIELD_NAME } from 'app/constants/BibConstants';
import { selectMediaSummaryForCurrentBib } from 'app/selectors/bibs/EvaluationSelector';
import { selectCatalogBib, createBibFieldSelector } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectBibEntities } from 'app/selectors/EntitiesSelector';
import { fieldShape } from 'app/shapes/bibPage';
import MediaSummary from './MediaSummary';

const selectAudienceInfo = createBibFieldSelector('AUDIENCE', FIELD_NAME.AUDIENCE_GENERAL);
const selectLanguageInfo = createBibFieldSelector('NOTES', FIELD_NAME.LANGUAGE);

export class MediaSummaryContainer extends React.PureComponent {
  render() {
    return <MediaSummary {...this.props} />;
  }
}

MediaSummaryContainer.propTypes = {
  bib: bibShape.isRequired,
  mediaSummary: PropTypes.string,
  audienceInfo: fieldShape,
  languageInfo: fieldShape
};

const mapStateToProps = state => {
  const catalogBib = selectCatalogBib(state);
  const metadataId = catalogBib.get('metadataId');
  const bib = selectBibEntities(state).get(metadataId);
  return {
    bib,
    mediaSummary: selectMediaSummaryForCurrentBib(state),
    audienceInfo: selectAudienceInfo(state),
    languageInfo: selectLanguageInfo(state)
  };
};

export default connect(mapStateToProps)(MediaSummaryContainer);
